// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vvavnBaTWO45N3r7uUpx {
    margin-bottom: 8px;
}

.vaSt20UWXkGOcAdRyTtX {
    margin-bottom: 24px;
    max-width: 560px;
}

.oUJpP2qDGsS9DuqBUqPA .of84nPS49ta9VaG7CeA1 {
    color: #999;
}

.of84nPS49ta9VaG7CeA1 {
    padding-left: 8px;
}

.of84nPS49ta9VaG7CeA1,
.WgUH99IiTbxYqMxVYnbQ {
    cursor: pointer;
}

.WgUH99IiTbxYqMxVYnbQ {
    align-items: center;
    display: flex;
    font-weight: 400;
    margin-bottom: 0;
}

input[type=checkbox].xE64Gi8WbAV_yr39OklJ {
    margin: 0;
}

.ULMCqmzUQBAKD1WNsiTX + .ULMCqmzUQBAKD1WNsiTX {
    margin-top: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/settings/property/stages/settings.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;IAEI,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,eAAe;AACnB","sourcesContent":[".title {\n    margin-bottom: 8px;\n}\n\n.description {\n    margin-bottom: 24px;\n    max-width: 560px;\n}\n\n.inactive .name {\n    color: #999;\n}\n\n.name {\n    padding-left: 8px;\n}\n\n.name,\n.label {\n    cursor: pointer;\n}\n\n.label {\n    align-items: center;\n    display: flex;\n    font-weight: 400;\n    margin-bottom: 0;\n}\n\ninput[type=checkbox].toggle {\n    margin: 0;\n}\n\n.stage + .stage {\n    margin-top: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `vvavnBaTWO45N3r7uUpx`,
	"description": `vaSt20UWXkGOcAdRyTtX`,
	"inactive": `oUJpP2qDGsS9DuqBUqPA`,
	"name": `of84nPS49ta9VaG7CeA1`,
	"label": `WgUH99IiTbxYqMxVYnbQ`,
	"toggle": `xE64Gi8WbAV_yr39OklJ`,
	"stage": `ULMCqmzUQBAKD1WNsiTX`
};
export default ___CSS_LOADER_EXPORT___;
